import React, { useEffect, useRef, useState } from 'react';

export default function CorporateEngagementsSection() {
  const [hoveredCard, setHoveredCard] = useState(null);
  const [expandedImage, setExpandedImage] = useState(null);
  const [showcaseHovered, setShowcaseHovered] = useState(false);
  const [showcaseClicked, setShowcaseClicked] = useState(false);
  const showcaseTimerRef = useRef(null);

  useEffect(() => {
    return () => {
      if (showcaseTimerRef.current) {
        clearTimeout(showcaseTimerRef.current);
      }
    };
  }, []);

  const handleShowcaseClick = () => {
    setShowcaseClicked(true);
    if (showcaseTimerRef.current) {
      clearTimeout(showcaseTimerRef.current);
    }
    showcaseTimerRef.current = setTimeout(() => {
      setShowcaseClicked(false);
    }, 3000);
  };

  const showShowcaseMessage = showcaseHovered || showcaseClicked;

  const events = [
    {
      id: 1,
      image: '/img/event1.jpeg',
      alt: 'Past Event 1'
    },
    {
      id: 2,
      image: '/img/event2.jpeg',
      alt: 'Past Event 2'
    },
    {
      id: 3,
      image: '/img/ds3.jpeg',
      alt: 'Past Event 3'
    }
  ];

  return (
    <section className="relative bg-white py-24 lg:py-32 overflow-hidden border-b border-gray-200">
      {/* Background Elements */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-amber-500/5 rounded-full blur-[150px] pointer-events-none z-0"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-blue-600/5 rounded-full blur-[120px] pointer-events-none z-0"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10">
        
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center border border-gray-200 px-4 py-2 bg-gray-50 text-xs font-bold uppercase tracking-widest text-amber-600 mb-4 rounded-md shadow-sm">
            <span className="w-2 h-2 bg-amber-500 rounded-full mr-3 animate-pulse shadow-[0_0_8px_rgba(245,158,11,0.8)]"></span>
            Community & Leadership
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight uppercase mb-4 text-gray-900">
            Shaping the Future of <span className="text-amber-600">Tech</span>
          </h2>
          <p className="text-gray-600 text-base sm:text-lg leading-relaxed max-w-2xl mx-auto font-medium">
            We believe in building the future, not just using it. This section highlights our commitment to the tech community through leadership at key summits, hands-on workshops, and competitive hackathons where we foster the next generation of talent.
          </p>
        </div>

        {/* 3 Photo Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {events.map((event) => (
            <div
              key={event.id}
              className="group rounded-3xl overflow-hidden shadow-lg border border-gray-100 hover:shadow-2xl hover:-translate-y-2 transition-all duration-500 cursor-pointer"
              onMouseEnter={() => setHoveredCard(event.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="relative h-80 overflow-hidden">
                <img
                  src={event.image}
                  alt={`Garud Stacks at a tech community event: ${event.alt}`}
                  onClick={() => setExpandedImage(event.image)}
                  className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110 cursor-pointer"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-80 group-hover:opacity-60 transition-opacity duration-500 pointer-events-none"></div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <button
            type="button"
            onMouseEnter={() => setShowcaseHovered(true)}
            onMouseLeave={() => setShowcaseHovered(false)}
            onFocus={() => setShowcaseHovered(true)}
            onBlur={() => setShowcaseHovered(false)}
            onClick={handleShowcaseClick}
            className="inline-flex items-center justify-center px-8 py-4 bg-gray-900 text-white font-bold uppercase tracking-widest text-xs sm:text-sm rounded-xl hover:bg-amber-500 hover:text-black transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_30px_-10px_rgba(245,158,11,0.5)]"
          >
            Student Innovation Showcase
          </button>

          <div className="mt-4 min-h-[28px]">
            <p
              className={`text-sm font-semibold text-amber-700 transition-all duration-300 ${
                showShowcaseMessage ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-1 pointer-events-none'
              }`}
            >
              Coming soon: We are launching this showcase very soon.
            </p>
          </div>
        </div>
        
        {/* Expanded Image Modal */}
        {expandedImage && (
          <div 
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
            onClick={() => setExpandedImage(null)}
          >
            <div 
              className="relative w-full max-w-4xl max-h-[90vh] rounded-2xl overflow-hidden shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={expandedImage}
                alt="Expanded view"
                className="w-full h-full object-contain"
              />
              <button
                onClick={() => setExpandedImage(null)}
                className="absolute top-4 right-4 w-10 h-10 bg-white/20 hover:bg-white/40 rounded-full flex items-center justify-center transition-colors duration-300 backdrop-blur-sm"
              >
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div>
          </div>
        )}
        
      </div>
    </section>
  );
}
